import React, {useState} from 'react'
import {plaidIcon} from '../assets'
import {ParagraphText, Icon} from '@thryvlabs/maverick'
import {PaymentMethodContainer} from '../ui-view/payment-information'
import {AchPaymentForm} from './ach-payment-form'
import {BecsPaymentForm} from './becs-payment-form'
import {PaymentForm} from './recurly-payment-form'
import {useViewport} from '../utils/useViewport'
import {useDispatch, useSelector} from 'react-redux'
import {prevPaymentStep} from '../redux/paymentScreenViewSlice'

import {
  AUS_PAYMENT_METHODS,
  PAYMENT_METHODS,
} from './keap-partner/payment-information-components/constants/index'
// import {usePaymentOrder} from './keap-partner/payment-information-components/hooks/use-payment-order'

export const PaymentMethodComponent = ({
  paymentState,
  calculateTaxes,
  isTaxCalculated,
  setTaxCalculateStatus,
  paymentUUID,
  accountInformation,
  handleChangePaymentMethod,
  paymentMethod,
  setPaymentRequestState,
  country = 'US',
  keapPartnerLinkDetail,
}) => {
  const [calculatingTaxes, setCalculatingTaxes] = useState({})
  const [isAddressUpdated, setIsAddressUpdated] = useState(false)
  const [checkBoxesValues, setCheckBoxesValues] = React.useState({
    agreedTerms: false,
    agreedPromotionalInfo: false,
    useBusinessAddressInfo: false,
    updateBillingAddress: false,
  })
  const [name, setName] = useState('')
  console.log(isAddressUpdated, name)
  console.log(paymentState)
  // const {is5Order} = usePaymentOrder()
  const is5Order = true
  const {isMobile} = useViewport()
  const dispatch = useDispatch()
  // const isDesktop = !isMobile
  const {isMobileViewEnable} = useSelector(state => state.screenView)
  const {paymentCurrentStep} = useSelector(state => state.paymentScreenView)

  const isAus = keapPartnerLinkDetail?.country_code === 'AU'
  const isNZ = keapPartnerLinkDetail?.country_code === 'NZ'
  const paymentMethods = isAus
    ? AUS_PAYMENT_METHODS
    : isNZ
      ? [PAYMENT_METHODS[0]]
      : PAYMENT_METHODS
  // const calculatingTaxes= {}
  const paymentPreview = {}
  const handleCompleteOrder = () => {}

  // const handleOnCheckBoxChange = () => {
  //   setCheckBoxesValues(prev => !prev)
  // }

  const handleOnCheckBoxChange = ({target: {name}}) => {
    setCheckBoxesValues(prevState => ({
      ...prevState,
      [name]: !prevState[name],
    }))
  }
  console.log({isMobileViewEnable, paymentMethod})
  const renderPaymentMethodView = () => {
    return (
      <PaymentMethodContainer
        is5Order={is5Order}
        isDesktop={!isMobileViewEnable}
        className={`d-flex mb-4  justify-content-start`}
      >
        {paymentMethods.map((method, index) => {
          const isPlaid = method.name === 'Bank Transfer with ACH'

          return (
            <div
              key={index}
              className={`payment-method p-2 ${
                paymentMethod.value === method.value ? 'active' : ''
              } ${isMobileViewEnable ? 'w-100' : ''}`}
              onClick={() => handleChangePaymentMethod(method)}
            >
              {isPlaid && is5Order ? (
                <img
                  src={plaidIcon}
                  alt="plaid icon"
                  height="16px"
                  width="16px"
                  className="mb-1"
                />
              ) : (
                <Icon
                  type="solid"
                  variant={method.icon}
                  className={`${is5Order && 'mb-1'}`}
                  style={{
                    height: is5Order ? '11px' : 'auto',
                    width: is5Order ? '15px' : 'auto',
                  }}
                />
              )}
              <ParagraphText variant="sm" className="fw-bold m-0">
                {isPlaid && is5Order ? 'Transfer with ACH' : method.name}
              </ParagraphText>
            </div>
          )
        })}
      </PaymentMethodContainer>
    )
  }
  return (
    <>
      {isMobileViewEnable ? (
        <>
          {paymentCurrentStep === 1 && renderPaymentMethodView()}{' '}
          {paymentCurrentStep > 1 && paymentCurrentStep <= 3 && (
            <div className={`d-flex mb-4 pt-4`}>
              <Icon
                type="solid"
                variant="chevronLeft"
                className="mr-4"
                style={{
                  height: '20px',
                  width: '20px',
                }}
                onClick={() => {
                  dispatch(prevPaymentStep())
                }}
              />
              {paymentCurrentStep === 2 && (
                <ParagraphText variant="lg" className="font-weight-bold mb-0">
                  {paymentMethod?.value.includes('card')
                    ? 'Credit/Debit Card'
                    : paymentMethod?.value.includes('ach')
                      ? 'ACH'
                      : 'BECS'}
                </ParagraphText>
              )}
              {paymentCurrentStep === 3 && (
                <ParagraphText variant="lg" className="font-weight-bold mb-0">
                  Billing Address
                </ParagraphText>
              )}
            </div>
          )}
        </>
      ) : (
        <>{renderPaymentMethodView()}</>
      )}

      {paymentMethod?.value.length > 0 ? (
        <>
          {paymentMethod?.value.includes('card') ? (
            <PaymentForm
              calculateTaxes={calculateTaxes}
              calculatingTaxes={calculatingTaxes}
              setCalculatingTaxes={setCalculatingTaxes}
              checkBoxesValues={checkBoxesValues}
              handleOnCheckBoxChange={handleOnCheckBoxChange}
              businessAddress={accountInformation}
              country={country || paymentState?.paymentInfo?.country}
              setName={setName}
              handleCompleteOrder={handleCompleteOrder}
              setIsAddressUpdated={setIsAddressUpdated}
              setTaxCalculateStatus={setTaxCalculateStatus}
              isTaxCalculated={isTaxCalculated}
              bizphone={accountInformation?.phone}
              is5Order={is5Order}
              isAddressUpdated={isAddressUpdated}
              paymentPreview={paymentPreview}
              accountInformation={accountInformation}
              setPaymentRequestState={setPaymentRequestState}
              keapPartnerLinkDetail={keapPartnerLinkDetail}
              showFirstSection={paymentCurrentStep === 2}
              showSecondSection={paymentCurrentStep === 3}
            />
          ) : paymentMethod?.value.includes('ach') ? (
            <AchPaymentForm
              uuid={paymentUUID}
              calculateTaxes={calculateTaxes}
              setCalculatingTaxes={setCalculatingTaxes}
              checkBoxesValues={checkBoxesValues}
              handleOnCheckBoxChange={handleOnCheckBoxChange}
              handleCompleteOrder={handleCompleteOrder}
              businessAddress={accountInformation}
              setName={setName}
              setIsAddressUpdated={setIsAddressUpdated}
              isMobile={isMobile}
              is5Order={false}
              accountInformation={accountInformation}
              showFirstSection={paymentCurrentStep === 2}
              showSecondSection={paymentCurrentStep === 3}
              country={country || paymentState?.paymentInfo?.country}
            />
          ) : (
            <BecsPaymentForm
              uuid={paymentUUID}
              calculateTaxes={calculateTaxes}
              setCalculatingTaxes={setCalculatingTaxes}
              checkBoxesValues={checkBoxesValues}
              handleOnCheckBoxChange={handleOnCheckBoxChange}
              handleCompleteOrder={handleCompleteOrder}
              businessAddress={accountInformation}
              setName={setName}
              setIsAddressUpdated={setIsAddressUpdated}
              isMobile={isMobile}
              is5Order={false}
              accountInformation={accountInformation}
              showFirstSection={paymentCurrentStep === 2}
              showSecondSection={paymentCurrentStep === 3}
              country={country || paymentState?.paymentInfo?.country}
            />
          )}
        </>
      ) : (
        <></>
      )}
    </>
  )
}
